export default{
    
    lista:{
        method:'get',
        url:'desligamento/trabalhador/lista'
    },
    pesquisa:{
        method:'get',
        url:'boletins/tabela/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'desligamento/trabalhador/cadastro'
    },
    delete:{
        method:'delete',
        url:'desligamento/trabalhador/deletar{/id}'
    },
    deleteremoneracaoempresa:{
        method:'delete',
        url:'desligamento/remoneracao/empresa/trabalhador/deletar{/id}'
    },
    deletevalorcalculo:{
        method:'delete',
        url:'desligamento/valor/calculo/trabalhador/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'desligamento/trabalhador/editar{/id}'
    },
    update:{
        method:'post',
        url:'desligamento/trabalhador/update'
    },
    numero:{
        method:'post',
        url:'boletins/cartaoponto/numero/max'
    },
    update2299:{
        method:'put',
        url:'desligamento/trabalhador/2299/update'
    },
    cadastra2299:{
        method:'post',
        url:'desligamento/trabalhador/2299/cadastro'
    },
    delete2299:{
        method:'delete',
        url:'desligamento/trabalhador/2299/deletar{/id}'
    },
    update2399:{
        method:'put',
        url:'desligamento/trabalhador/2399/update'
    },
    cadastra2399:{
        method:'post',
        url:'desligamento/trabalhador/2399/cadastro'
    },
    delete2399:{
        method:'delete',
        url:'desligamento/trabalhador/2399/deletar{/id}'
    },
}
